import * as yup from "yup";

export default function useProductSchema(code) {
  const isUpdate = !!code;
  const isRetailProduct = !code;

  const numberField = (label) =>
    yup
      .number()
      .transform((value, originalValue) => {
        if (typeof originalValue === "string") {
          const numeric = originalValue.replace(/[^\d.-]/g, "");
          return numeric === "" ? undefined : Number(numeric);
        }
        return value;
      })
      .typeError(`${label} phải là số`)
      .min(0, `${label} không được âm`);

  const validationSchema = yup.object().shape({
    code: yup.string().when([], {
      is: () => isUpdate,
      then: (s) => s.required("Thông tin bắt buộc"),
      otherwise: (s) => s.notRequired(),
    }),
    unit: yup.string().when([], {
      is: () => !isUpdate,
      then: (s) => s.required("Thông tin bắt buộc"),
      otherwise: (s) => s.notRequired(),
    }),
    vat: yup.string().when([], {
      is: () => !isUpdate,
      then: (s) => s.required("Thông tin bắt buộc"),
      otherwise: (s) => s.notRequired(),
    }),
    brand: yup.string().when([], {
      is: () => !isUpdate,
      then: (s) => s.required("Thông tin bắt buộc"),
      otherwise: (s) => s.notRequired(),
    }),
    manufacturer: yup.string().when([], {
      is: () => isUpdate,
      then: (s) => s.required("Thông tin bắt buộc"),
      otherwise: (s) => s.notRequired(),
    }),
    shelfLife: yup.string().when([], {
      is: () => isUpdate,
      then: (s) => s.required("Thông tin bắt buộc"),
      otherwise: (s) => s.notRequired(),
    }),
    notificationNo: yup.string().when([], {
      is: () => !isUpdate,
      then: (s) => s.required("Thông tin bắt buộc"),
      otherwise: (s) => s.notRequired(),
    }),
    name: yup.string().required("Thông tin bắt buộc"),
    unit: yup.string().required("Thông tin bắt buộc"),
    image: yup.string().when([], {
      is: () => !isUpdate,
      then: (s) => s.required("Thông tin bắt buộc"),
      otherwise: (s) => s.notRequired(),
    }),
    // shortName: yup.string().required("Thông tin bắt buộc"),

    productModels: yup
      .array()
      .of(
        yup.object().shape({
          name: yup.string().when([], {
            is: () => isRetailProduct,
            then: (s) => s.required("Thông tin bắt buộc"),
            otherwise: (s) => s.notRequired(),
          }),
          barcode: yup.string().when([], {
            is: () => !isUpdate,
            then: (s) => s.required("Thông tin bắt buộc"),
            otherwise: (s) => s.notRequired(),
          }),
          code: yup.string().when([], {
            is: () => !isUpdate,
            then: (s) => s.required("Thông tin bắt buộc"),
            otherwise: (s) => s.notRequired(),
          }),
          sku: yup.string().when([], {
            is: () => isRetailProduct,
            then: (s) => s.required("Thông tin bắt buộc"),
            otherwise: (s) => s.notRequired(),
          }),
          image: yup.string().when([], {
            is: () => !isUpdate,
            then: (s) => s.required("Thông tin bắt buộc").typeError("Ảnh mô hình không hợp lệ"),
            otherwise: (s) => s.notRequired(),
          }),
          price: numberField("Giá niêm yết").when(["name", "barcode", "code", "sku", "image"], {
            is: (name, barcode, code, sku, image) => Boolean(name || barcode || code || sku || image),
            then: (s) => s.required("Thông tin bắt buộc"),
            otherwise: (s) => s.notRequired(),
          }),
        }),
      )
      .nullable()
      .notRequired(),
  });

  return { validationSchema };
}
